@if (mode === 'renderer') {
  <div class="products-dc-canvas">
    @if (listItems && listItems.length > 0) {
      <div class="row">
        @for (item of listItems; track item.id) {
          <div class="col-6 col-md-4 col-lg-3 mb-2">
            <ng-container *ngComponentOutlet="item.component; inputs: { data: item.data }"></ng-container>
          </div>
        }
      </div>
    }
    @if (defaultViewComponent && defaultViewData && defaultViewData.length > 0) {
      <ng-container *ngComponentOutlet="defaultViewComponent; inputs: { data: defaultViewData, refreshTrigger: defaultViewData }"></ng-container>
    }
    @if (element.fields.productsIds && element.fields.productsIds.length === 0 && edit) {
      <div class="text-center p-4">Add Products in editor</div>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="row">
    <div class="col-12">
      <div class="d-flex flex-column mt-2">
        <label for="typeahead-prevent-manual-entry">
          {{ 'Product ID to Add' | translate }}
          @if (loadingProducts) {
            <span class="spinner-border spinner-border-sm ms-1" role="status"></span>
          }
        </label>
        <input
          #productElement
          id="typeahead-prevent-manual-entry"
          type="text"
          class="form-control"
          [(ngModel)]="productToAdd"
          [disabled]="loadingProducts"
          [ngbTypeahead]="search"
          [inputFormatter]="inputFormatter"
          [resultFormatter]="resultFormatter"
          (selectItem)="addProduct($event.item)"
        />
      </div>
    </div>
    <div class="col-12" cdkDropList (cdkDropListDropped)="dropProduct($event)">
      @for(productId of element.fields.productsIds; track productId) {
        <div class="product-id-row d-flex align-items-center mt-2" cdkDrag>
          <div class="drag-handle pe-2" cdkDragHandle>
            <i class="fa-solid fa-up-down-left-right"></i>
          </div>
          <div class="flex-grow-1">{{ productId }}</div>
          <i class="fa-solid fa-trash cursor-pointer" (click)="deleteProduct(productId)"></i>
          
          <ng-template cdkDragPreview>
            <div class="product-id-row d-flex align-items-center p-2 w-100">
              <i class="fa-solid fa-up-down-left-right pe-2"></i>
              <div class="flex-grow-1">{{ productId }}</div>
            </div>
          </ng-template>

          <ng-template cdkDragPlaceholder>
            <div class="product-id-row placeholder w-100"></div>
          </ng-template>
        </div>
      }
    </div>
  </div>
}

@if (mode === 'preview') {
  <div class="pl-preview">
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
    <div class="pl-item">
      <i class="fa-solid fa-image"></i>
      <div class="pl-name">Product</div>
    </div>
  </div>
}
